module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-7-1.629723f9.png";